module.exports = __webpack_public_path__ + "img/icon-environment.46526d83.svg";